import _typeof from "@babel/runtime/helpers/typeof";
// Copyright 1999-2018. Plesk International GmbH. All rights reserved.
var baseUrl = '';

if ((typeof window === "undefined" ? "undefined" : _typeof(window)) === 'object' && typeof window.require === 'function' && typeof window.require.toUrl === 'function') {
  baseUrl = window.require.toUrl('plesk-ui-library');
} else {
  var script = document.querySelector('script[src*="plesk-ui-library.js"], script[src*="plesk-ui-library.min.js"]');

  if (script) {
    baseUrl = script.src;
  }
}

if (baseUrl) {
  baseUrl = baseUrl.substr(0, baseUrl.lastIndexOf('/') + 1);
}
/* eslint-disable no-undef, camelcase */


if (typeof __webpack_public_path__ !== 'undefined' && baseUrl) {
  __webpack_public_path__ = baseUrl;
}
/* eslint-enable no-undef, camelcase */
// Workaround for ES6 module detection


export default null;